import { render, staticRenderFns } from "./ProdutoEdit.vue?vue&type=template&id=9c192dc0&scoped=true&"
import script from "./ProdutoEdit.vue?vue&type=script&lang=js&"
export * from "./ProdutoEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoEdit.vue?vue&type=style&index=0&id=9c192dc0&prod&scoped=true&lang=css&"
import style1 from "./ProdutoEdit.vue?vue&type=style&index=1&id=9c192dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c192dc0",
  null
  
)

export default component.exports